<template>
  <div class="comment-row">
    <div class="comment-row_info">
      <img v-if="item.user.headUrl" class="comment-row_info-head" :src="item.user.headUrl" alt="头像" @click="routeToUser(item.user)"/>
      <img v-else class="comment-row_info-head" src="@/assets/img/user.png" alt="头像" @click="routeToUser(item.user)"/>
      <div class="comment-row_info-name" @click="routeToUser(item.user)">{{ item.user.userName }}</div>
      <div class="comment-row_info-time">{{ timeString }}</div>
    </div>
    <div style="margin-left:34px">
      <span v-if="item.replyUserInfo" class="comment-row_text">
        回复<span class="comment-row_name">
              {{ item.replyUserInfo.userName }}<span class="comment-row_text">{{ ' ' + item.content }}</span>
            </span>
      </span>
      <span v-else class="comment-row_text">{{ item.content }}</span>
      <div class="comment-row_options">
        <a-icon type="message" theme="filled" class="comment-row_options-open" @click="openComment(item.id)"/>
        <a-icon v-if="showDelete" theme="filled" type="delete" class="comment-row_options-delete" @click="delComment"/>
      </div>
      <div v-if="showComment" style="margin-bottom:10px">
        <a-textarea
          class="comment-row_edit"
          v-model="reCommentEdit"
          :placeholder="`回复${item.user.userName}`"
          :auto-size="{ minRows: 3, maxRows: 5 }"
          :maxlength="500"
        />
        <div style="display:flex;justify-content:flex-end">
          <a-button class="comment-row_publish" type="primary" @click="onComment" :disabled="reCommentEdit === ''">回复评论</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addComment } from '@/utils/api.js'
import { formatTime } from '@/utils'

export default {
  props: {
    item:{type:Object,default:()=>{}},
    showComment:{type:Boolean,default:false}
  },
  data() {
    return {
      reCommentEdit: ''
    }
  },
  computed: {
    // 是否登录用户
    isLogin() {
      return !!this.$store.state.userInfo.uid
    },
    postsId() {
      return this.$route.params.id
    },
    showDelete() {
      return (this.item.user.userId === this.$store.state.userInfo.uid) || this.$store.state.userStatic.adminFlag
    },
    timeString() {
      return formatTime(this.item.createTime)
    }
    
  },
  methods: {
    openComment(id) {
      this.$emit('click',id)
    },
    onComment() {
      // 未登录，跳转登录页
      if(!this.isLogin) {
        window.location.href = `/auth/login?fromUrl=https%3A%2F%2F${window.location.host}%2Fporos-community%2Findex`
        return
      }
      this.$emit('comment')
      const params = {
        commentId: this.item.commentId ? this.item.commentId : this.item.id,
        content: this.reCommentEdit,
        postsId: this.postsId,
        replyId: this.item.id,
        replyUser: this.item.user.userId
      }
      addComment(params).then(res => {
        this.$emit('finish')
        if (res.code === 0) {
          this.reCommentEdit = ''
          this.$message.success('评论成功')
        } else {
          this.$message.error('评论失败')
        }
      })
    },
    delComment() {
      this.$emit('delete',this.item.id)
    },
    routeToUser(user) {
      const url = `/user-article-list/${user.userId}`
      if(this.$route.path === url) return
      this.$router.push(`${url}?userName=${user.userName}&headUrl=${user.headUrl || ''}`)
    }
  }
}
</script>

<style lang="less" scoped>
.comment-row {
  &_info {
    display: flex;
    align-items: center;
    &-head {
      cursor: pointer;
      width: 24px;
      border-radius: 50%;
      border: 1px solid #e5e6e9;
    }
    &-name {
      cursor: pointer;
      margin-left: 10px;
      font-size: 14px;
      color: rgba(4,12,44,0.85);
      letter-spacing: 0;
      line-height: 22px;
      font-weight: 400;
      &:hover {
        color: #1740DC;
      }
    }
    &-time {
      margin-left: 10px;
      font-size: 12px;
      color: rgba(4,12,44,0.45);
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;
    }
  }
  &_text {
    margin-top: 5px;
    font-size: 12px;
    color: rgba(4,12,44,0.45);
    letter-spacing: 0;
    line-height: 18px;
    font-weight: 400;
  }
  &_name {
    font-size: 12px;
    color: rgba(4,12,44,0.85);
    letter-spacing: 0;
    text-align: justify;
    line-height: 18px;
    font-weight: 400;
  }
  &_options {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    &-open {
      cursor: pointer;
      color: #CDCED5;
      font-size: 16px;
    }
    &-delete {
      cursor: pointer;
      color: #CDCED5;
      font-size: 16px;
      margin-left:20px
    }
  }
  &_publish {
    margin-top: 10px;
  }
  &_reply {
    display: flex;
    &-text {
      font-size: 12px;
      color: rgba(4,12,44,0.45);
      letter-spacing: 0;
      text-align: justify;
      line-height: 18px;
      font-weight: 400;
    }
    &-name {
      font-size: 12px;
      color: rgba(4,12,44,0.85);
      letter-spacing: 0;
      text-align: justify;
      line-height: 18px;
      font-weight: 400;
    }
  }
}
</style>